(function () {
  function initVimeoHover() {
    var elements = document.querySelectorAll(".product-card__vimeo--hover");

    elements.forEach(function (el) {
      if (el.dataset.vimeoInitialized) return;
      el.dataset.vimeoInitialized = "true";

      el.addEventListener(
        "mouseenter",
        function onMouseenter() {
          var url = el.getAttribute("data-video-url");
          var placeholder = el.querySelector(".product-card__image-vimeo");

          if (!url || !placeholder) return;

          var iframe = document.createElement("iframe");
          iframe.src = url;
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute(
            "allow",
            "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media",
          );
          iframe.style.cssText =
            "position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;pointer-events:none;transform: translate(0.5%, -9%) scale(1.2);";

          var cardTitle = el.closest(".product-card-new");
          if (cardTitle) {
            var titleEl = cardTitle.querySelector(".product-card__title");
            if (titleEl) {
              iframe.title = titleEl.textContent.trim();
            }
          }

          placeholder.replaceWith(iframe);
        },
        { once: true },
      );
    });
  }

  initVimeoHover();
  document.addEventListener("DOMContentLoaded", initVimeoHover);
  setTimeout(initVimeoHover, 500);
  setTimeout(initVimeoHover, 1500);
})();